import { useDispatch } from 'react-redux';
import React from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { captureException } from '@playbookux/playbook-web-core';

import { signInWithPathfix } from '../../../core/actions';

import {
  Container,
  Loader,
  Logo,
  Text,
  Title,
} from './styles';

const providers = {
  googleidentity: 'Google',
  fbidentity: 'Facebook',
};

export default function PathfixCallback({ location: { search } }) {
  const dispatch = useDispatch();
  const [error, setError] = React.useState(false);
  const { oauthId: id, provider: type } = queryString.parse(search);

  React.useEffect(() => {
    if (id && type) {
      try {
        dispatch(signInWithPathfix(id, type));
      } catch (e) {
        setError(true);
        captureException('AUTHENTICATING_WITH_PATHFIX_FAILURE', e);
      }
    }
  }, []);

  if (!id && !type) return null;

  if (error) {
    return (
      <Container>
        <Logo
          src="/images/playbook-logo.png"
          alt="Playbook"
        />

        <Text>
          Error while authenticating with
          {' '}
          {providers[type] ?? 'Pathfix'}
          . Please
          {' '}
          <Link to="/sign-in">try again</Link>
          .
        </Text>
      </Container>
    );
  }

  return (
    <Container>
      <Logo
        src="/images/playbook-logo.png"
        alt="Playbook"
      />

      <Loader size="large" data-loader="path-loader" />

      <Title>
        Authenticating with
        {' '}
        {providers[type] ?? 'Pathfix'}
        ...
      </Title>
    </Container>
  );
}

PathfixCallback.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};
